import { getWeekdays } from "@components/inputs/date/utils";
import { IPrAttendanceEntity, IPrWorkingPatternEntity } from "@odata/GeneratedEntityTypes";
import { PrWorkingPatternTypeCode } from "@odata/GeneratedEnums";
import { getWorkingPatternDaysMap } from "@pages/payroll/attendance/Attendance.utils";
import { roundToDecimalPlaces } from "@utils/general";
import React, { Component } from "react";

import { Button } from "../../../components/button";
import Dialog from "../../../components/dialog/Dialog";
import DateType, { DateFormat, getUtcDayjs } from "../../../types/Date";
import { FormStorage } from "../../../views/formView/FormStorage";
import {
    AdditionalInfo,
    CalendarGrid,
    CalendarWrapper,
    Day,
    DayLabel,
    MonthYearLabel,
    UnevenWorkingPatternWrapper
} from "./Attendance.styles";
import { IAttendanceCustomData } from "./AttendanceFormView";

interface IProps {
    storage: FormStorage<IPrAttendanceEntity, IAttendanceCustomData>;
    onClose: (isConfirmed: boolean) => void;
    workingPattern: IPrWorkingPatternEntity;
}

export default class UsedWorkingPatternOverview extends Component<IProps> {
    handleCancel = (): void => {
        this.props.onClose(false);
    };

    renderContent(): React.ReactNode {
        if (!this.props.workingPattern) {
            return null;
        }

        if (this.props.workingPattern.TypeCode === PrWorkingPatternTypeCode.Uneven) {
            const { BalancingPeriodWeeks, HoursPerWeekFullTime } = this.props.workingPattern;
            return <>
                <UnevenWorkingPatternWrapper>{this.props.storage.t("Attendance:Form.Uneven")}</UnevenWorkingPatternWrapper>
                <AdditionalInfo>
                    {this.props.storage.t("Attendance:Form.WeekWorkHours")}
                    <b>&nbsp;{HoursPerWeekFullTime}&nbsp;{this.props.storage.t("Common:Time.Hours", { count: HoursPerWeekFullTime })}</b>
                </AdditionalInfo>
                <AdditionalInfo>
                    {this.props.storage.t("Attendance:Form.BalancingPeriod")}
                    <b>&nbsp;{BalancingPeriodWeeks}&nbsp;{this.props.storage.t("Common:Time.Week", { count: BalancingPeriodWeeks })}</b>
                </AdditionalInfo>

            </>;
        }

        const weekdayLabels = getWeekdays();
        const entity = this.props.storage.data.entity;
        const startOfMonth = getUtcDayjs().set("month", entity.Month - 1).set("year", entity.Year).startOf("month");
        const firstDayOfMonthWeekday = startOfMonth.get("day");
        const offsetLength = firstDayOfMonthWeekday === 0 ? 6 : firstDayOfMonthWeekday - 1;

        const monthHolidays = this.props.storage.getCustomData().holidays;
        const fundMap = getWorkingPatternDaysMap(this.props.workingPattern, startOfMonth, monthHolidays);

        const totalFund = roundToDecimalPlaces(1, Object.values(fundMap).reduce((total, f) => {
            return total + f;
        }, 0));

        return <>
            <MonthYearLabel>
                {DateType.format(startOfMonth.toDate(), DateFormat.monthAndYear)}
            </MonthYearLabel>
            <CalendarGrid>
                {weekdayLabels.map((day, index) => <DayLabel key={day + index}>{day}</DayLabel>)}
                {Array.from(Array(offsetLength).keys()).map((h, index) => {
                    return <Day key={"dummy" + index}/>;
                })}
                {Object.values(fundMap).map((h, index) => {
                    return <Day key={index}>
                        {h}
                    </Day>;
                })}
            </CalendarGrid>
            <AdditionalInfo>
                {this.props.storage.t("Attendance:Form.WorkingHoursFund")}
                <b>&nbsp;{totalFund}&nbsp;{this.props.storage.t("Components:Calendar.HourPlaceholder")}</b>
            </AdditionalInfo>
        </>;
    }

    render() {
        return <Dialog title={this.props.storage.t("Attendance:Form.UsedPattern")}
                       width={"420px"}
                       onClose={this.handleCancel}
                       onConfirm={null}
                       footer={
                           <>
                               <Button isTransparent
                                       onClick={this.handleCancel}>
                                   {this.props.storage.t("Common:General.Close")}
                               </Button>
                           </>
                       }>
            <CalendarWrapper>
                {this.renderContent()}
            </CalendarWrapper>
        </Dialog>;
    }
}